module.exports = __webpack_public_path__ + "img/hr-garballo-00.2114ee85.png";